/**
 * Captures UTM parameters from the initial page URL at module load time.
 *
 * React Navigation may strip query params from the browser URL when it
 * resolves the initial route. By capturing them at import time (before any
 * component renders), we guarantee the values are available for analytics
 * regardless of what happens to window.location later.
 */

import { Platform } from 'react-native';

const search =
  Platform.OS === 'web' && typeof window !== 'undefined'
    ? window.location.search
    : '';

const params = new URLSearchParams(search);

export const initialUtmParams: Record<string, string | undefined> = {
  utm_source: params.get('utm_source') || undefined,
  utm_medium: params.get('utm_medium') || undefined,
  utm_campaign: params.get('utm_campaign') || undefined,
  utm_content: params.get('utm_content') || undefined,
  utm_term: params.get('utm_term') || undefined,
};

/**
 * Returns true if the initial URL had at least one UTM parameter.
 */
export const hasInitialUtm = Object.values(initialUtmParams).some(Boolean);
